// Auto-generated from defaultTranslations
// ⚠️ DO NOT EDIT ⚠️ 
/* eslint-disable */

export const CATEGORY_LABELS = {
  CATEGORY_LABELS: "category_labels",
  LANGUAGE_HANDLING: "language_handling",
  APP: "app",
  GENERAL: "general",
  ACTIONS: "actions",
  RIVA: "riva",
  BPA: "bpa",
  RAD: "RAD",
  MODEL: "model",
  LABELS: "labels",
};

export const LANGUAGE_HANDLING = {
  LANGUAGE: "language",
  SELECT_LANGUAGE: "select_language",
  LANG_CURATED: "lang_curated",
  LANG_STANDARD: "lang_standard",
  LANG_CUSTOM: "lang_custom",
  LANG_FICTIONAL: "lang_fictional",
};

export const MODEL = {
  MODEL_NAME: "model_name",
  MODEL_NAME_NOTE: "model_name_note",
  MODEL_PURPOSE: "model_purpose",
  PURPOSE_NOTE: "purpose_note",
  MODEL_DESCRIPTION: "model_description",
  MODEL_VIEWPOINT: "model_viewpoint",
  MODEL_CHANGED: "model_changed",
};

export const APP = {
  APP_TITLE: "app_title",
  HOME: "home",
  ARCHITECTURE: "architecture",
  THEME: "theme",
  SETTINGS: "settings",
  HELP: "help",
  TRANSLATION_EDITOR: "translation_editor",
  TRANSLATION_NOTICE: "translation_notice",
  EXAMPLES: "examples",
  EDITORPREFS: "editorprefs",
  CUSTOM_COLOR: "custom_color",
};

export const RAD = {
  ROLE: "role",
  THREAD: "thread",
  STATE: "state",
  INTERACTION: "interaction",
  ACTION: "action",
  TRIGGER: "trigger",
  STARTROLE: "startrole",
  CASEREFINE: "caserefine",
  PARTREFINE: "partrefine",
  PARTREPEAT: "partrepeat",
  SPRING: "spring",
  CONNECTION: "connection",
  INITIATOR: "initiator",
};

export const BPA = {
  ARCH: "arch",
  EBES: "ebes",
  GEN: "gen",
  UOW: "uow",
  UOW_NOTE: "uow_note",
  FIRST_CUT: "first_cut",
  SECOND_CUT: "second_cut",
};

export const RIVA = {
  PROJECT: "project",
  EDITOR: "editor",
};

export const LABELS = {
  NAME: "name",
  DESCRIPTION: "description",
  TYPE: "type",
  STATUS: "status",
  PURPOSE: "purpose",
  VERSION: "version",
  DATE_CREATED: "date_created",
  DATE_MODIFIED: "date_modified",
};

export const ACTIONS = {
  OPEN: "open",
  CLOSE: "close",
  EDIT: "edit",
  NEW: "new",
  SAVE: "save",
  LOAD: "load",
  CANCEL: "cancel",
  CLEAR: "clear",
  DELETE: "delete",
  REMOVE: "remove",
  ADD: "add",
  UNDO: "undo",
  REDO: "redo",
  UNDO_ALL: "undo_all",
  REDO_ALL: "redo_all",
  CLEAR_HISTORY: "clear_history",
  SELECT: "select",
  EXPORT: "export",
  IMPORT: "import",
  RESET: "reset",
  ZOOM_IN: "zoom_in",
  ZOOM_OUT: "zoom_out",
  ZOOM_RESET: "zoom_reset",
  ZOOM_MAX: "zoom_max",
  ZOOM_MIN: "zoom_min",
  ZOOM_TO_FIT: "zoom_to_fit",
  SHOW_PRINT_MODAL: "show_print_modal",
  SHOW_FULLSCREEN: "show_fullscreen",
  EXIT_FULLSCREEN: "exit_fullscreen",
  PRINT: "print",
};


export const TRANSLATION_KEYS = {
  CATEGORY_LABELS: "category_labels",
  LANGUAGE_HANDLING: "language_handling",
  APP: "app",
  GENERAL: "general",
  ACTIONS: "actions",
  RIVA: "riva",
  BPA: "bpa",
  RAD: "RAD",
  MODEL: "model",
  LABELS: "labels",
  LANGUAGE: "language",
  SELECT_LANGUAGE: "select_language",
  LANG_CURATED: "lang_curated",
  LANG_STANDARD: "lang_standard",
  LANG_CUSTOM: "lang_custom",
  LANG_FICTIONAL: "lang_fictional",
  MODEL_NAME: "model_name",
  MODEL_NAME_NOTE: "model_name_note",
  MODEL_PURPOSE: "model_purpose",
  PURPOSE_NOTE: "purpose_note",
  MODEL_DESCRIPTION: "model_description",
  MODEL_VIEWPOINT: "model_viewpoint",
  MODEL_CHANGED: "model_changed",
  APP_TITLE: "app_title",
  HOME: "home",
  ARCHITECTURE: "architecture",
  THEME: "theme",
  SETTINGS: "settings",
  HELP: "help",
  TRANSLATION_EDITOR: "translation_editor",
  TRANSLATION_NOTICE: "translation_notice",
  EXAMPLES: "examples",
  EDITORPREFS: "editorprefs",
  CUSTOM_COLOR: "custom_color",
  ROLE: "role",
  THREAD: "thread",
  STATE: "state",
  INTERACTION: "interaction",
  ACTION: "action",
  TRIGGER: "trigger",
  STARTROLE: "startrole",
  CASEREFINE: "caserefine",
  PARTREFINE: "partrefine",
  PARTREPEAT: "partrepeat",
  SPRING: "spring",
  CONNECTION: "connection",
  INITIATOR: "initiator",
  ARCH: "arch",
  EBES: "ebes",
  GEN: "gen",
  UOW: "uow",
  UOW_NOTE: "uow_note",
  FIRST_CUT: "first_cut",
  SECOND_CUT: "second_cut",
  PROJECT: "project",
  EDITOR: "editor",
  NAME: "name",
  DESCRIPTION: "description",
  TYPE: "type",
  STATUS: "status",
  PURPOSE: "purpose",
  VERSION: "version",
  DATE_CREATED: "date_created",
  DATE_MODIFIED: "date_modified",
  OPEN: "open",
  CLOSE: "close",
  EDIT: "edit",
  NEW: "new",
  SAVE: "save",
  LOAD: "load",
  CANCEL: "cancel",
  CLEAR: "clear",
  DELETE: "delete",
  REMOVE: "remove",
  ADD: "add",
  UNDO: "undo",
  REDO: "redo",
  UNDO_ALL: "undo_all",
  REDO_ALL: "redo_all",
  CLEAR_HISTORY: "clear_history",
  SELECT: "select",
  EXPORT: "export",
  IMPORT: "import",
  RESET: "reset",
  ZOOM_IN: "zoom_in",
  ZOOM_OUT: "zoom_out",
  ZOOM_RESET: "zoom_reset",
  ZOOM_MAX: "zoom_max",
  ZOOM_MIN: "zoom_min",
  ZOOM_TO_FIT: "zoom_to_fit",
  SHOW_PRINT_MODAL: "show_print_modal",
  SHOW_FULLSCREEN: "show_fullscreen",
  EXIT_FULLSCREEN: "exit_fullscreen",
  PRINT: "print",
};
